// extracted by mini-css-extract-plugin
module.exports = {"productDetailContainerDiv":"styles_productDetailContainerDiv__3v_re","description":"styles_description__19vuy"};